import {
  nextColumnSort,
  type ColumnSort,
  type ColumnSortDirection,
} from '@/lib/column-sort'

export const JOB_LIST_SORT_COLUMNS = [
  'date_raised',
  'assigned_partner_name',
  'job_type',
  'location_id',
  'road_name',
  'town_county',
  'asset_location',
  'severity',
  'status',
] as const

export type JobListSortColumn = (typeof JOB_LIST_SORT_COLUMNS)[number]
export type JobListSort = ColumnSort<JobListSortColumn>

export const DEFAULT_JOB_LIST_SORT: JobListSort = {
  column: 'date_raised',
  direction: 'desc',
}

const DEFAULT_DIRECTION: Record<JobListSortColumn, ColumnSortDirection> = {
  date_raised: 'desc',
  assigned_partner_name: 'asc',
  job_type: 'asc',
  location_id: 'asc',
  road_name: 'asc',
  town_county: 'asc',
  asset_location: 'asc',
  severity: 'asc',
  status: 'asc',
}

export const isJobListSortColumn = (
  value: string
): value is JobListSortColumn =>
  (JOB_LIST_SORT_COLUMNS as readonly string[]).includes(value)

export const nextJobListSort = (
  current: JobListSort,
  column: string
): JobListSort =>
  nextColumnSort(current, column, {
    isColumn: isJobListSortColumn,
    defaultDirection: DEFAULT_DIRECTION,
  })
